<div id="ballot-creator">
    <!-- Matrix Selection -->
    <app-matrix *ngIf="currentStep==='matrix'"
        [type]="type"
        (valueChange)="setMatrix($event)"
    ></app-matrix>

    <!-- Create Ballot -->
    <app-ballot *ngIf="currentStep==='ballot'"
        [type]="type"
        [matrixArray]="matrixArray"
        [players]="players"
        (selectPlayer)="selectPlayer($event)"
        (saveBallot)="saveBallot($event)"
        (goBack)="goTo('matrix')"
    ></app-ballot>

    <!-- Select Player -->
    <app-player *ngIf="currentStep==='player'"
        [currentStepObservable]="currentStepObservable"
        (playerSelected)="playerSelected($event)"
        (goBack)="goTo('ballot')"
    ></app-player>
</div>